import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "../../../components/ThemeSwitcher/ThemeSwitcher";
import { useTranslation } from "react-i18next";
import { createPortal } from "react-dom";
import { showAlert } from "../../../utils/Helpers";
import "../AnimalApprovedRecords.css";
import { Button, Form } from "react-bootstrap";
import { MdOutlineDelete } from "react-icons/md";
import { LuCheck } from "react-icons/lu";
import { FiUpload, FiEdit2, FiEye } from "react-icons/fi";
import { RxCalendar } from "react-icons/rx";
import { HiMiniEllipsisVertical } from "react-icons/hi2";
import { BiArrowBack } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import Select from "react-select";
import CustomDropdownIndicator from "../../../components/common/CustomDropdownIndicator";
import "react-tooltip/dist/react-tooltip.css";
import "../AnimalSightingMobile/AnimalSightingMobile.css";
import { useEDPContext } from "../../../components/EDPContext";
import { Popover } from "react-bootstrap";

let editingRows = [];
var sketchVM = null;
var sketch = null;
const AnimalSightingMobilePending = ({
  data,
  GetFamilyDropdown,
  GetSpeciesDropdown,
  domainValues,
  DropdownSpeciesValues,
  DropdownFamilyValues,
  modalProps,
  t,
  commonProps,
  InsectsData,
  IsDataModified,
  onClose,
  fullView,
  ...props
}) => {
  const { mapview, showForm, setShowForm, sptledit, setSptlEdit } = props;
  const { theme } = useTheme();
  //const { t } = useTranslation();
  const IconAttachtarget = useRef(null);
  const { globalDataContextValue } = useEDPContext();
  const { globalData, setGlobalData } = globalDataContextValue;
  const AnimalSightingTab = globalData.find(module => module.moduleName === "Animal Sighting")
    ?.subTabs.find(subTab => subTab.name === "PendingRecords");
  const {
    handleSave,
    handleRowSelection,
    handleInputChange,
    ApproveFeatures,
    handleIndputDropdownChange,
    activePendingtabs,
    modalObjectId,
    showPopover,
    handleTabChange,
    fileUpload,
    handleDelete,
    ViewFeatureonMap,
  } = commonProps;
  const {
    attachmentsContent,
    handleShow,
    uploadAttachments,
    fileInputRef,
    handleFileChange,
    selectedFiles,
    handleAttachClick,
    handleDrop,
    handleDragOver,
    handleRemoveFile,
  } = modalProps;
  const [invertebratesData, setInvertebratesData] = useState(null);
  const [plantsData, setPlantsData] = useState(null);
  const [mammalData, setMammalsData] = useState(null);
  const [reptilesData, setReptilesData] = useState(null);
  const [currentSelectedRow, setCurrentSelectedRow] = useState([]);
  const [currentClonedRow, setcurrentClonedRow] = useState(null);
  const [isEditingCompleted, setIsEditingCompleted] = useState(IsDataModified);
  const [speciesOrder, setSpeciesOrder] = useState(null);
  const [speciesName, setSpeciesName] = useState(null);
  const [speciesFamily, setSpeciesFamily] = useState(null);
  const [species, setSpecies] = useState(null);
  const [reptiles, setReptiles] = useState(null);
  const [widgetMobEl, setWidgetMobEl] = useState(null);

  const [actionTask, setActionTask] = useState(null);
  const [showmobilePopover, setShowMobilePopover] = useState(false);

  const animalData = [
    {
      id: 1,
      title: "Odonta (Dragon Flies)",
      family: "Libellulidae",
      species: "Crocothemis Erythraea",
      tag: "Natural",
      location: "UAE",
      habitat: "Coastal",
      date: "24/03/2024",
    },
    {
      id: 2,
      title: "Psocoptera (Psocids)",
      family: "Troglidae",
      species: "Lepinotus Reticulatus",
      tag: "Protected Areas",
      location: "UAE",
      habitat: "Forest",
      date: "12/05/2024",
    },
  ];

  useEffect(() => {
    setIsEditingCompleted(IsDataModified);
  }, [IsDataModified]);

  useEffect(() => {
    if (activePendingtabs.includes(t("Invertebrates"))) {
      setInvertebratesData(data);
    } else if (activePendingtabs.includes(t("Plants"))) {
      setPlantsData(data);
    } else if (activePendingtabs.includes(t("Mammals"))) {
      setMammalsData(data);
    } else if (activePendingtabs.includes(t("Reptiles"))) {
      setReptilesData(data);
    }
  }, [data, activePendingtabs, t]);
  useEffect(() => { }, [data, activePendingtabs]);
  const [editingCardId, setEditingCardId] = useState(null);
  const [previewCardId, setPreviewCardId] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(null);

  // const toggleEdit = (id) => {
  //   setEditingCardId((prevId) => (prevId === id ? null : id));
  //   setIsDropdownOpen(null);
  //   setIsEditingCompleted(false);
  //   var selectedRow = data.current.filter((feature) => {
  //     return feature.id == id;
  //   });
  //   handleShow(selectedRow[0], true);
  //   // handleRowSelection(selectedRow[0].id)
  //   setCurrentSelectedRow(selectedRow);
  //   setcurrentClonedRow(selectedRow[0]);

  //   if (activePendingtabs.includes("Invertebrates")) {
  //     setSpeciesOrder(selectedRow[0].InsectOrder);
  //     setSpeciesName(selectedRow[0].SpeciesName);
  //     setSpeciesFamily(selectedRow[0].Family);
  //     GetFamilyDropdown(selectedRow[0].InsectOrder);
  //     GetSpeciesDropdown(selectedRow[0].Family);
  //   } else if (activePendingtabs.includes("Mammals")) {
  //     setSpecies(selectedRow[0].Species);
  //     setSpeciesName(selectedRow[0].SpeciesName);

  //     GetSpeciesDropdown(selectedRow[0].Species);
  //   } else if (activePendingtabs.includes("Reptiles")) {
  //     setReptiles(selectedRow[0].Reptiles);
  //     setSpecies(selectedRow[0].Species);

  //     GetSpeciesDropdown(selectedRow[0].Reptiles);
  //   }
  // };


  const toggleEdit = (id, action) => {
    if (action == "Edit") {
      setEditingCardId((prevId) => (prevId === id ? null : id));      
    }
    else if (action == "Preview") {
      setPreviewCardId((prevId) => (prevId === id ? null : id));
    }
    else {
      setEditingCardId(false);
    }

    setIsDropdownOpen(null);
    setIsEditingCompleted(false);
    var selectedRow = data.current.filter((feature) => {
      return feature.id == id;
    });
    handleShow(selectedRow[0], true);
    // handleRowSelection(selectedRow[0].id)
    setCurrentSelectedRow(selectedRow);
    setcurrentClonedRow(selectedRow[0]);
    setActionTask(action);

    if (activePendingtabs.includes(t("Invertebrates"))) {
      setSpeciesOrder(selectedRow[0].InsectOrder);
      setSpeciesName(selectedRow[0].SpeciesName);
      setSpeciesFamily(selectedRow[0].Family);
      GetFamilyDropdown(selectedRow[0].InsectOrder);
      GetSpeciesDropdown(selectedRow[0].Family);
    } else if (activePendingtabs.includes(t("Mammals"))) {
      setSpecies(selectedRow[0].Species);
      setSpeciesName(selectedRow[0].SpeciesName);

      GetSpeciesDropdown(selectedRow[0].Species);
    } else if (activePendingtabs.includes(t("Reptiles"))) {
      setReptiles(selectedRow[0].Reptiles);
      setSpecies(selectedRow[0].Species);

      GetSpeciesDropdown(selectedRow[0].Reptiles);
    }
  };


  useEffect(() => {
    if (currentSelectedRow.length > 0) {
      if (actionTask === "View") {
        ViewFeatureonMap();
      }
      else if (actionTask === "Approve") {
        ApproveFeatures();
      }
      else if (actionTask === "Delete") {
        //handleRowSelection(currentSelectedRow[0].id);
        handleDelete();
      }
      // else if (actionTask === "Edit") {
      //   setEditingCardId((prevId) => (prevId === currentSelectedRow[0].id ? null : currentSelectedRow[0].id));
      // }
    }
  }, [currentSelectedRow, actionTask])

  const toggleDropdown = (id) => {
    setIsDropdownOpen((prevId) => (prevId === id ? null : id));
    handleRowSelection(id);
  };

  const formatToDatetimeLocal = (dateString) => {
    if (!dateString) return "";
    if (dateString.includes("T") == true) {
      const DateVal = dateString.split("T");
      const [year, month, day] = DateVal[0].split("-");
      const [time] = DateVal[1];
      return `${year}-${month}-${day}T${DateVal[1]}`;
    } else {
      const [day, month, yearAndTime] = dateString.split("-");
      const [year, time] = yearAndTime.split(" ");
      return `${year}-${month}-${day}T${time.slice(0, 5)}`;
    }
  };

  const handleEditDropdownChange = (selectedOption, key) => {
    DropdownSpeciesValues = [];

    // Create a copy of the current cloned row
    editingRows = { ...currentClonedRow };

    editingRows[key] = selectedOption ? selectedOption : "";
    setcurrentClonedRow(editingRows);
    handleInputChange(currentClonedRow.id, key, selectedOption);
  };
  useEffect(() => {
    if (editingRows != null) {
      if (!editingRows.InsectOrder) {
        setSpeciesOrder(null);
      } else {
        setSpeciesOrder(editingRows.InsectOrder);
      }
      if (!editingRows.Family) {
        setSpeciesFamily(null);
      } else {
        setSpeciesFamily(editingRows.Family);
      }
      if (!editingRows.SpeciesName) {
        setSpeciesName(null);
      } else {
        setSpeciesName(editingRows.SpeciesName);
      }
      if (!editingRows.Species) {
        setSpecies(null);
      } else {
        setSpecies(editingRows.Species);
      }
    }
  }, [editingRows]);
  const handleEditSave = () => {
    if (activePendingtabs.includes(t("Invertebrates"))) {
      const existsFamilyDropdown = DropdownFamilyValues.some(
        item => item.value === speciesFamily
      );
      const existsSpeciesDropdown = DropdownSpeciesValues.some(
        item => item.value === speciesName
      );
      if (
        existsFamilyDropdown &&
        existsSpeciesDropdown &&
        speciesOrder != null
      ) {
        handleSave([currentClonedRow.id]);
        uploadAttachments(currentClonedRow.OBJECTID, true);
        handleEditCancel();
      } else {
        showAlert(t("selectorenter"), "info");
      }
    } else if (activePendingtabs.includes(t("Mammals"))) {
      const existsSpeciesDropdown = DropdownSpeciesValues.some(
        item => item.value === speciesName
      );
      if (existsSpeciesDropdown && species != null) {
        handleSave([currentClonedRow.id]);
        uploadAttachments(currentClonedRow.OBJECTID, true);
        handleEditCancel();
      } else {
        showAlert(t("selectorenter"), "info");
      }
    } else if (activePendingtabs.includes(t("Reptiles"))) {
      const existsSpeciesDropdown = DropdownSpeciesValues.some(
        item => item.value === species
      );
      if (reptiles != null && existsSpeciesDropdown) {
        handleSave([currentClonedRow.id]);
        uploadAttachments(currentClonedRow.OBJECTID, true);
        handleEditCancel();
      } else {
        showAlert(t("selectorenter"), "info");
      }
    } else {
      handleSave([currentClonedRow.id]);
      uploadAttachments(currentClonedRow.OBJECTID, true);
      handleEditCancel();
    }
  };
  const handleEditCancel = () => {
    setEditingCardId(false);
    setcurrentClonedRow(null);
    if (isEditingCompleted == false) {
      resetFeatureData();
    }
  };
  const resetFeatureData = () => {
    data.current = data.current.map(
      (features) =>
        features.id === currentSelectedRow[0].id
          ? { ...currentSelectedRow[0] } // Reset the specific feature
          : features // Keep the other features unchanged
    );
  };

  const handleOpenAttachment=(animal)=>{
    setShowMobilePopover(true);
    handleShow(animal, true);
  }

  const useIsMobile = (breakpoint = 768) => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth <= breakpoint);
      };

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  };

  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) {
      if (fullView) {
        const fullContainer = document.querySelector('body');
        setWidgetMobEl(fullContainer);
      } else {
        const mobEl = document.getElementById('widgetMob');
        setWidgetMobEl(mobEl);
      }
    }
  }, [isMobile, fullView]);

  useEffect(() => {
    if (showmobilePopover) {
      const arrowElement = document.querySelector(".popover-arrow");
      const handleClickOnArrow = (event) => {
        handleClose();
      };
      if (arrowElement) {
        arrowElement.addEventListener("click", handleClickOnArrow);
      }
      return () => {
        if (arrowElement) {
          arrowElement.removeEventListener("click", handleClickOnArrow);
        }
      };
    }
  }, [showmobilePopover]);
  const handleClose = () => {
    setShowMobilePopover(false);
  };

  return (
    <>
      {activePendingtabs.includes(t("Invertebrates")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {data &&
                data.current.length > 0 &&
                data.current.map((animal) => (
                  <div key={animal.id} className="animalMobCard" data-objectid={animal.OBJECTID}>
                    <div className="aniMobCardHeader">
                      <h3>{animal.InsectOrder}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(animal.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === animal.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(animal.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "View")}>    {/*  ViewFeatureonMap() */}
                              <FiEye className="me-2" />
                              {t("view")}
                            </li>
                            <li onClick={fileUpload}>
                              <FiUpload className="me-2" />
                              {t("Upload")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Approve")}>   {/*  ApproveFeatures(); */}
                              <LuCheck
                                className="me-2"
                                size={15}
                                title="Approve"
                              />
                              {t("Approve")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Delete")}>     {/*  handleDelete */}
                              <MdOutlineDelete className="me-2" />
                              {t("delete")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Preview")}>
                              <FiEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{animal.Family}</p>
                          <p className="mb-0">{animal.SpeciesName}</p>
                        </div>
                        <div className="aniMobTag">{animal.HabitatStatus}</div>
                      </div>
                      <div className="aniMobDetails">
                        {/* <div className="aniMobDetailCard">
                          <p>{t("Species Name")}</p>
                          <p>{animal.SpeciesName}</p>
                        </div> */}
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{animal.Habitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Observation Date")}</p>
                          <p>{animal.SurveyDate}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Attachments")}</p>
                          <div className="col-md-12 popover-container">
                            <>
                              <img
                                src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                className="uploadicon mb-1"
                                ref={IconAttachtarget}
                                // onClick={() =>
                                //   handleShow(animal, true)
                                // } // Show modal on click
                                onClick={() => handleOpenAttachment(animal)}
                                alt="Attachment Icon"
                                style={{
                                  cursor: "pointer",
                                  width: "1.25rem",
                                }}
                              />
                              {showmobilePopover &&
                                modalObjectId ===
                                animal.OBJECTID && (
                                  <Popover
                                    show={showmobilePopover}
                                    target={
                                      IconAttachtarget.current
                                    }
                                  >
                                    <Popover.Body>
                                      {attachmentsContent}
                                      <Form>
                                        <Form.Group
                                          controlId="formFile"
                                          className="mb-3"
                                        >
                                          <Form.Label>
                                          {t("UploadAttachments")}
                                          </Form.Label>
                                          <Form.Control
                                            type="file"
                                            ref={
                                              fileInputRef
                                            }
                                            onChange={(e) =>
                                              handleFileChange(
                                                e.target
                                                  .files
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      </Form>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          uploadAttachments(
                                            animal.OBJECTID,
                                            true
                                          )
                                        }
                                      >
                                        {t("addattachment")}
                                      </Button>
                                    </Popover.Body>
                                  </Popover>
                                )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
          {editingCardId && currentSelectedRow && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.InvertiblesInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let InvertebratesdomainValues = [];

                    if (key === "Family") {
                      InvertebratesdomainValues = DropdownFamilyValues;
                    } else if (key === "SpeciesName") {
                      InvertebratesdomainValues = DropdownSpeciesValues;
                    } else {
                      InvertebratesdomainValues = domainValues[key] || [];
                    }

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "InsectOrder" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.InsectOrder
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.InsectOrder ||
                                            domain.value ===
                                            currentClonedRow.InsectOrder
                                        )
                                          ? {
                                            value:
                                              currentClonedRow.InsectOrder,
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.InsectOrder ||
                                                domain.value ===
                                                currentClonedRow.InsectOrder
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                      if (
                                        currentClonedRow.InsectOrder !=
                                        selectedOption
                                      ) {
                                        editingRows.Family = null;
                                        editingRows.SpeciesName = null;
                                      }

                                      GetFamilyDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Insect Order")}
                                  />
                                </>
                              ) : key === "Family" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.Family
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow.Family
                                        )
                                          ? {
                                            value: currentClonedRow.Family,
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow.Family
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                      if (
                                        currentClonedRow.Family !=
                                        selectedOption
                                      ) {
                                        editingRows.SpeciesName = null;
                                      }
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Family")}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                {currentClonedRow.created_date && (
                  <div className="card-row attachment-section">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="form-label">{t("Attachments")}</label>
                        <div> {attachmentsContent}</div>
                        <div
                          id="drag-area"
                          className="drag-area"
                          style={{
                            border: "2px dashed var(--animalFileBorder)",
                          }}
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                        >
                          <input
                            type="file"
                            className="file-input"
                            ref={fileInputRef}
                            onChange={(e) => {
                              handleFileChange(e.target.files);
                            }}
                            id="file-upload"
                            multiple
                            style={{ display: "none" }}
                          />
                          <img
                            src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                            className="uploadicon mb-1"
                            alt=""
                          />
                          <p className="mb-0" style={{ fontWeight: "600" }}>
                            Drag & Drop {t("Or")}
                            <button
                              className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                              onClick={() => {
                                handleAttachClick();
                              }}
                              style={{ fontWeight: "600" }}
                            >
                              Click to Upload
                            </button>
                          </p>
                          <p>JPEG, PNG, PDF and MP4 up to 5MB</p>
                          {selectedFiles.length > 0 && (
                            <div className="selected-files">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="selected-file">
                                  <span>{file.name}</span>
                                  <RiDeleteBinLine
                                    className="delete-icon"
                                    onClick={() => handleRemoveFile(file.name)}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Update")}
                </Button>
              </div>
            </div>, widgetMobEl
          )}

          {previewCardId && currentSelectedRow && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.InvertiblesInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let InvertebratesdomainValues = [];

                    if (key === "Family") {
                      InvertebratesdomainValues = DropdownFamilyValues;
                    } else if (key === "SpeciesName") {
                      InvertebratesdomainValues = DropdownSpeciesValues;
                    } else {
                      InvertebratesdomainValues = domainValues[key] || [];
                    }

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }

                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "InsectOrder" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.InsectOrder
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.InsectOrder ||
                                            domain.value ===
                                            currentClonedRow.InsectOrder
                                        )
                                          ? {
                                            value:
                                              currentClonedRow.InsectOrder,
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.InsectOrder ||
                                                domain.value ===
                                                currentClonedRow.InsectOrder
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                      if (
                                        currentClonedRow.InsectOrder !=
                                        selectedOption
                                      ) {
                                        editingRows.Family = null;
                                        editingRows.SpeciesName = null;
                                      }

                                      GetFamilyDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Insect Order")}
                                    isDisabled={true}
                                  />
                                </>
                              ) : key === "Family" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.Family
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow.Family
                                        )
                                          ? {
                                            value: currentClonedRow.Family,
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow.Family
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                      if (
                                        currentClonedRow.Family !=
                                        selectedOption
                                      ) {
                                        editingRows.SpeciesName = null;
                                      }
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Family")}
                                    isDisabled={true}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={InvertebratesdomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? InvertebratesdomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: InvertebratesdomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}
      {activePendingtabs.includes(t("Plants")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {data &&
                data.current.length > 0 &&
                data.current.map((animal) => (
                  <div key={animal.id} className="animalMobCard" data-objectid={animal.OBJECTID}>
                    <div className="aniMobCardHeader">
                      <h3>{animal.PlantSpecies}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(animal.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === animal.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(animal.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "View")}>
                              <FiEye className="me-2" />
                              {t("view")}
                            </li>
                            <li onClick={fileUpload}>
                              <FiUpload className="me-2" />
                              {t("Upload")}
                            </li>
                            <li
                              onClick={() => {
                                toggleEdit(animal.id, "Approve")
                              }}
                            >
                              <LuCheck
                                className="me-2"
                                size={15}
                                title="Approve"
                              />
                              {t("Approve")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Delete")}>
                              <MdOutlineDelete className="me-2" />
                              {t("delete")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Preview")}>
                              <FiEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{animal.Phenology}</p>
                          {/* <p className="mb-0">{animal.GrazingSigns}</p> */}
                        </div>
                        <div className="aniMobTag">{animal.GrazingSigns}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Precipitation")}</p>
                          <p>{animal.Precipitation}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{animal.Habitat}</p>
                        </div>
                        {/* <div className="aniMobDetailCard">
                          <p>{t("Survey Date")}</p>
                          <p>{animal.SurveyDate}</p>
                        </div> */}
                        <div className="aniMobDetailCard">
                          <p>{t("Attachments")}</p>
                          <div className="col-md-12 popover-container">
                            <>
                              <img
                                src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                className="uploadicon mb-1"
                                ref={IconAttachtarget}
                                onClick={() => handleOpenAttachment(animal)}
                                alt="Attachment Icon"
                                style={{
                                  cursor: "pointer",
                                  width: "1.25rem",
                                }}
                              />
                              {showmobilePopover &&
                                modalObjectId ===
                                animal.OBJECTID && (
                                  <Popover
                                    show={showmobilePopover}
                                    target={
                                      IconAttachtarget.current
                                    }
                                  >
                                    <Popover.Body>
                                      {attachmentsContent}
                                      <Form>
                                        <Form.Group
                                          controlId="formFile"
                                          className="mb-3"
                                        >
                                          <Form.Label>
                                          {t("UploadAttachments")}
                                          </Form.Label>
                                          <Form.Control
                                            type="file"
                                            ref={
                                              fileInputRef
                                            }
                                            onChange={(e) =>
                                              handleFileChange(
                                                e.target
                                                  .files
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      </Form>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          uploadAttachments(
                                            animal.OBJECTID,
                                            true
                                          )
                                        }
                                      >
                                        {t("addattachment")}
                                      </Button>
                                    </Popover.Body>
                                  </Popover>
                                )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {/* })
                    ) : alert("No Data found")
                    } */}
            </div>
          )}
          {editingCardId && currentSelectedRow && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    // setcurrentClonedRow(currentSelectedRow[0])
                    if (isEditingCompleted === false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.PlantInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let plantDomainValues = [];

                    plantDomainValues = domainValues[key] || [];

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }

                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                )
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={plantDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? {
                                          value: currentClonedRow[key],
                                          label:
                                            plantDomainValues.find(
                                              (option) =>
                                                option.value ===
                                                currentClonedRow[key]
                                            )?.value || `Select ${key}`,
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        //selectedOption.value,
                                        key === "Precipitation" ? selectedOption.label : selectedOption.value,
                                        key
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                {currentClonedRow.created_date && (
                  <div className="card-row attachment-section">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="form-label">{t("Attachments")}</label>
                        <div> {attachmentsContent}</div>
                        <div
                          id="drag-area"
                          className="drag-area"
                          style={{
                            border: "2px dashed var(--animalFileBorder)",
                          }}
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                        >
                          <input
                            type="file"
                            className="file-input"
                            ref={fileInputRef}
                            onChange={(e) => {
                              handleFileChange(e.target.files);
                            }}
                            id="file-upload"
                            multiple
                            style={{ display: "none" }}
                          />
                          <img
                            src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                            className="uploadicon mb-1"
                            alt=""
                          />
                          <p className="mb-0" style={{ fontWeight: "600" }}>
                            Drag & Drop {t("Or")}
                            <button
                              className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                              onClick={() => {
                                handleAttachClick();
                              }}
                              style={{ fontWeight: "600" }}
                            >
                              Click to Upload
                            </button>
                          </p>
                          <p>JPEG, PNG, PDF and MP4 up to 5MB</p>
                          {selectedFiles.length > 0 && (
                            <div className="selected-files">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="selected-file">
                                  <span>{file.name}</span>
                                  <RiDeleteBinLine
                                    className="delete-icon"
                                    onClick={() => handleRemoveFile(file.name)}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Update")}
                </Button>
              </div>
            </div>, widgetMobEl
          )}

          {previewCardId && currentSelectedRow && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.PlantInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let plantDomainValues = [];

                    plantDomainValues = domainValues[key] || [];

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }

                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };

                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={plantDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? {
                                          value: currentClonedRow[key],
                                          label:
                                            plantDomainValues.find(
                                              (option) =>
                                                option.value ===
                                                currentClonedRow[key]
                                            )?.value || `Select ${key}`,
                                        }
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        //selectedOption.value,
                                        key === "Precipitation" ? selectedOption.label : selectedOption.value,
                                        key
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}
      {activePendingtabs.includes(t("Mammals")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {data &&
                data.current.length > 0 &&
                data.current.map((animal) => (
                  <div key={animal.id} className="animalMobCard" data-objectid={animal.OBJECTID}>
                    <div className="aniMobCardHeader">
                      {/* <h3>{animal.Species.trim()}</h3> */}
                      <h3>{animal.Species ? animal.Species.trim() : ""}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(animal.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === animal.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(animal.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "View")}>
                              <FiEye className="me-2" />
                              {t("view")}
                            </li>
                            <li onClick={fileUpload}>
                              <FiUpload className="me-2" />
                              {t("Upload")}
                            </li>
                            <li
                              onClick={() => {
                                toggleEdit(animal.id, "Approve")
                              }}
                            >
                              <LuCheck
                                className="me-2"
                                size={15}
                                title="Approve"
                              />
                              {t("Approve")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Delete")}>
                              <MdOutlineDelete className="me-2" />
                              {t("delete")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Preview")}>
                              <FiEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{animal.SpeciesName}</p>
                          {/* <p className="mb-0">{animal.SightingType}</p> */}
                        </div>
                        <div className="aniMobTag">{animal.SightingType}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Location")}</p>
                          <p>{animal.Location}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{animal.Habitat}</p>
                        </div>
                        {/* <div className="aniMobDetailCard">
                          <p>{t("Survey Date")}</p>
                          <p>{animal.SurveyDate}</p>
                        </div> */}
                        <div className="aniMobDetailCard">
                          <p>{t("Attachments")}</p>
                          <div className="col-md-12 popover-container">
                            <>
                              <img
                                src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                className="uploadicon mb-1"
                                ref={IconAttachtarget}
                                onClick={() => handleOpenAttachment(animal)}
                                alt="Attachment Icon"
                                style={{
                                  cursor: "pointer",
                                  width: "1.25rem",
                                }}
                              />
                              {showmobilePopover &&
                                modalObjectId ===
                                animal.OBJECTID && (
                                  <Popover
                                    show={showmobilePopover}
                                    target={
                                      IconAttachtarget.current
                                    }
                                  >
                                    <Popover.Body>
                                      {attachmentsContent}
                                      <Form>
                                        <Form.Group
                                          controlId="formFile"
                                          className="mb-3"
                                        >
                                          <Form.Label>
                                          {t("UploadAttachments")}
                                          </Form.Label>
                                          <Form.Control
                                            type="file"
                                            ref={
                                              fileInputRef
                                            }
                                            onChange={(e) =>
                                              handleFileChange(
                                                e.target
                                                  .files
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      </Form>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          uploadAttachments(
                                            animal.OBJECTID,
                                            true
                                          )
                                        }
                                      >
                                        {t("addattachment")}
                                      </Button>
                                    </Popover.Body>
                                  </Popover>
                                )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {/* })
                    ) : alert("No Data found")
                    } */}
            </div>
          )}
          {editingCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    // setcurrentClonedRow(currentSelectedRow[0])
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.MammalsInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let mammalesDomainValues = [];
                    if (key === "SpeciesName") {
                      mammalesDomainValues = DropdownSpeciesValues;
                    } else {
                      mammalesDomainValues = domainValues[key] || [];
                    }

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "Species" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={mammalesDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.Species
                                        ? domainValues.Species.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.Species ||
                                            domain.value ===
                                            currentClonedRow.Species
                                        )
                                          ? {
                                            value: currentClonedRow.Species,
                                            label: domainValues.Species.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.Species ||
                                                domain.value ===
                                                currentClonedRow.Species
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                      if (
                                        currentClonedRow.Species !=
                                        selectedOption
                                      ) {
                                        editingRows.SpeciesName = null;
                                      }
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    // handleOrderChange(selectedOption, currentClonedRow)

                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Insect Order")}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={mammalesDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? mammalesDomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: mammalesDomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );

                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                {currentClonedRow.created_date && (
                  <div className="card-row attachment-section">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="form-label">{t("Attachments")}</label>
                        <div> {attachmentsContent}</div>
                        <div
                          id="drag-area"
                          className="drag-area"
                          style={{
                            border: "2px dashed var(--animalFileBorder)",
                          }}
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                        >
                          <input
                            type="file"
                            className="file-input"
                            ref={fileInputRef}
                            onChange={(e) => {
                              handleFileChange(e.target.files);
                            }}
                            id="file-upload"
                            multiple
                            style={{ display: "none" }}
                          />
                          <img
                            src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                            className="uploadicon mb-1"
                            alt=""
                          />
                          <p className="mb-0" style={{ fontWeight: "600" }}>
                            Drag & Drop {t("Or")}
                            <button
                              className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                              onClick={() => {
                                handleAttachClick();
                              }}
                              style={{ fontWeight: "600" }}
                            >
                              Click to Upload
                            </button>
                          </p>
                          <p>JPEG, PNG, PDF and MP4 up to 5MB</p>
                          {selectedFiles.length > 0 && (
                            <div className="selected-files">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="selected-file">
                                  <span>{file.name}</span>
                                  <RiDeleteBinLine
                                    className="delete-icon"
                                    onClick={() => handleRemoveFile(file.name)}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Update")}
                </Button>
              </div>
            </div>, widgetMobEl
          )}

          {previewCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.MammalsInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let mammalesDomainValues = [];
                    if (key === "SpeciesName") {
                      mammalesDomainValues = DropdownSpeciesValues;
                    } else {
                      mammalesDomainValues = domainValues[key] || [];
                    }

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "SurveyDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "Species" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={mammalesDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.Species
                                        ? domainValues.Species.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.Species ||
                                            domain.value ===
                                            currentClonedRow.Species
                                        )
                                          ? {
                                            value: currentClonedRow.Species,
                                            label: domainValues.Species.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.Species ||
                                                domain.value ===
                                                currentClonedRow.Species
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );
                                      if (
                                        currentClonedRow.Species !=
                                        selectedOption
                                      ) {
                                        editingRows.SpeciesName = null;
                                      }
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    // handleOrderChange(selectedOption, currentClonedRow)

                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Species")}
                                    isDisabled={true}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={mammalesDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? mammalesDomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: mammalesDomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.value,
                                        key
                                      );

                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.value
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}
      {activePendingtabs.includes(t("Reptiles")) && (
        <>
          {!editingCardId && (
            <div className="animalMobCardWrp mobileOnly">
              {data &&
                data.current.length > 0 &&
                data.current.map((animal) => (
                  <div key={animal.id} className="animalMobCard" data-objectid={animal.OBJECTID}>
                    <div className="aniMobCardHeader">
                      <h3>{animal.Reptiles}</h3>
                      <button
                        className="aniMobMenuButton"
                        onClick={() => toggleDropdown(animal.id)}
                      >
                        <HiMiniEllipsisVertical />
                      </button>

                      {isDropdownOpen === animal.id && (
                        <div className="aniMobMenu">
                          <ul>
                            <li onClick={() => toggleEdit(animal.id, "Edit")}>
                              <FiEdit2 className="me-2" />
                              {t("edit")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "View")}>
                              <FiEye className="me-2" />
                              {t("view")}
                            </li>
                            <li onClick={fileUpload}>
                              <FiUpload className="me-2" />
                              {t("Upload")}
                            </li>
                            <li
                              onClick={() => {
                                toggleEdit(animal.id, "Approve")
                              }}
                            >
                              <LuCheck
                                className="me-2"
                                size={15}
                                title="Approve"
                              />
                              {t("Approve")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Delete")}>
                              <MdOutlineDelete className="me-2" />
                              {t("delete")}
                            </li>
                            <li onClick={() => toggleEdit(animal.id, "Preview")}>
                              <FiEye className="me-2" />
                              {t("Preview")}
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                    <div className="aniMobCardContent">
                      <div className="d-flex justify-content-between align-items-end">
                        <div>
                          <p>{animal.Species}</p>
                          {/* <p className="mb-0">{animal.Reptiles}</p> */}
                        </div>
                        <div className="aniMobTag">{animal.SightingType}</div>
                      </div>
                      <div className="aniMobDetails">
                        <div className="aniMobDetailCard">
                          <p>{t("Micro Habitat")}</p>
                          <p>{animal.MicroHabitat}</p>
                        </div>
                        <div className="aniMobDetailCard">
                          <p>{t("Habitat")}</p>
                          <p>{animal.Habitat}</p>
                        </div>
                        {/* <div className="aniMobDetailCard">
                          <p>{t("Observation Date")}</p>
                          <p>{animal.ObservationDate}</p>
                        </div> */}
                        <div className="aniMobDetailCard">
                          <p>{t("Attachments")}</p>
                          <div className="col-md-12 popover-container">
                            <>
                              <img
                                src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                                className="uploadicon mb-1"
                                ref={IconAttachtarget}
                                onClick={() => handleOpenAttachment(animal)}
                                alt="Attachment Icon"
                                style={{
                                  cursor: "pointer",
                                  width: "1.25rem",
                                }}
                              />
                              {showmobilePopover &&
                                modalObjectId ===
                                animal.OBJECTID && (
                                  <Popover
                                    show={showmobilePopover}
                                    target={
                                      IconAttachtarget.current
                                    }
                                  >
                                    <Popover.Body>
                                      {attachmentsContent}
                                      <Form>
                                        <Form.Group
                                          controlId="formFile"
                                          className="mb-3"
                                        >
                                          <Form.Label>
                                          {t("UploadAttachments")}
                                          </Form.Label>
                                          <Form.Control
                                            type="file"
                                            ref={
                                              fileInputRef
                                            }
                                            onChange={(e) =>
                                              handleFileChange(
                                                e.target
                                                  .files
                                              )
                                            }
                                          />
                                        </Form.Group>
                                      </Form>
                                      <Button
                                        variant="primary"
                                        onClick={() =>
                                          uploadAttachments(
                                            animal.OBJECTID,
                                            true
                                          )
                                        }
                                      >
                                        {t("addattachment")}
                                      </Button>
                                    </Popover.Body>
                                  </Popover>
                                )}
                            </>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              {/* })
                    ) : alert("No Data found")
                    } */}
            </div>
          )}
          {editingCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setEditingCardId(false);
                    setcurrentClonedRow(null);
                    // setcurrentClonedRow(currentSelectedRow[0])
                    if (isEditingCompleted == false) {
                      resetFeatureData();
                    }
                  }}
                />
                <h5>{t("edit")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.ReptilesInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let reptilsDomainValues = [];
                    if (key === "Species") {
                      reptilsDomainValues = DropdownSpeciesValues;
                    } else {
                      reptilsDomainValues = domainValues[key] || [];
                    }

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "ObservationDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "Reptils" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={reptilsDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.Reptils
                                        ? domainValues.Reptils.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.Reptils ||
                                            domain.value ===
                                            currentClonedRow.Reptils
                                        )
                                          ? {
                                            value: currentClonedRow.Reptils,
                                            label: domainValues.Reptils.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.Reptils ||
                                                domain.value ===
                                                currentClonedRow.Reptils
                                            ).value,
                                          }
                                          : (editingRows.Reptiles = null)
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.label,
                                        key
                                      );
                                      if (
                                        currentClonedRow.Reptils !=
                                        selectedOption
                                      ) {
                                        editingRows.Species = null;
                                      }
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.label
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Insect Order")}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={reptilsDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? reptilsDomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: reptilsDomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.label,
                                        key
                                      );
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.label
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                {currentClonedRow.created_date && (
                  <div className="card-row attachment-section">
                    <div className="col-md-12">
                      <div className="form-group">
                        <label className="form-label">{t("Attachments")}</label>
                        <div> {attachmentsContent}</div>
                        <div
                          id="drag-area"
                          className="drag-area"
                          style={{
                            border: "2px dashed var(--animalFileBorder)",
                          }}
                          onDrop={handleDrop}
                          onDragOver={handleDragOver}
                        >
                          <input
                            type="file"
                            className="file-input"
                            ref={fileInputRef}
                            onChange={(e) => {
                              handleFileChange(e.target.files);
                            }}
                            id="file-upload"
                            multiple
                            style={{ display: "none" }}
                          />
                          <img
                            src={`${process.env.PUBLIC_URL}/images/animalattachicon.svg`}
                            className="uploadicon mb-1"
                            alt=""
                          />
                          <p className="mb-0" style={{ fontWeight: "600" }}>
                            Drag & Drop {t("Or")}
                            <button
                              className="link-secondary-forgot text-decoration-none nobuttonStyle link-color"
                              onClick={() => {
                                handleAttachClick();
                              }}
                              style={{ fontWeight: "600" }}
                            >
                              Click to Upload
                            </button>
                          </p>
                          <p>JPEG, PNG, PDF and MP4 up to 5MB</p>
                          {selectedFiles.length > 0 && (
                            <div className="selected-files">
                              {selectedFiles.map((file, index) => (
                                <div key={index} className="selected-file">
                                  <span>{file.name}</span>
                                  <RiDeleteBinLine
                                    className="delete-icon"
                                    onClick={() => handleRemoveFile(file.name)}
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="historicalFoter d-flex gap-2 py-3 panelfooter">
                <Button variant="outline" onClick={handleEditCancel}>
                  {t("cancel")}
                </Button>
                <Button variant="primary" onClick={handleEditSave}>
                  {t("Update")}
                </Button>
              </div>
            </div>, widgetMobEl
          )}

          {previewCardId && isMobile && widgetMobEl && createPortal(
            <div className="aniMobEditWrp">
              <div className="d-flex align-items-center gap-2 mb-3">
                <BiArrowBack
                  size={20}
                  onClick={() => {
                    setPreviewCardId(false);
                  }}
                />
                <h5>{t("Preview")}</h5>
              </div>
              <div className="asCardSectinWrp">
                {Object.keys(currentClonedRow)
                  .filter(
                    (key) =>
                      key !== "OBJECTID" &&
                      key != "id" &&
                      key !== "Status" &&
                      key !== "DataSource" &&
                      key !== "GlobalID"
                  )
                  .map((key) => {
                    const filteredAttributes = window.ReptilesInfo.DisplayAttributes.filter(
                      (attr) =>
                        attr.AttrName !== "id" &&
                        attr.AttrName !== "created_date" &&
                        attr.AttrName !== "Status" &&
                        attr.AttrName !== "DataSource" &&
                        attr.AttrName !== "GlobalID" &&
                        attr.AttrName === key
                    );
                    let reptilsDomainValues = [];
                    if (key === "Species") {
                      reptilsDomainValues = DropdownSpeciesValues;
                    } else {
                      reptilsDomainValues = domainValues[key] || [];
                    }

                    const formatKeyLabel = (key) => {
                      // if (/^[A-Z0-9_]+$/.test(key)) {
                      //   return key;
                      // }
                      const fixedLabels = {
                        "point_x": "Point_X",
                        "point_y": "Point_Y",
                      };
                      const lowerKey = key.toLowerCase();
                      if (fixedLabels[lowerKey]) {
                        return fixedLabels[lowerKey];
                      }
                      return key
                        .replace(/_/g, ' ')                          // Replace underscores with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')         // Space between camelCase
                        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
                    };
                    return (
                      <>
                        <div
                          className="card-container"
                          key={currentClonedRow.id}
                        >
                          <div className="card-row" key={key}>
                            {currentClonedRow.id &&
                              filteredAttributes.length > 0 ? (
                              filteredAttributes[0].Domains === false ? (
                                key === "ObservationDate" ||
                                  key === "created_date" ? (
                                  <div className="dateInputBlk">
                                    <label>{formatKeyLabel(key)}</label>
                                    <input
                                      type="datetime-local"
                                      className="form-control"
                                      value={
                                        currentClonedRow[currentClonedRow.id]?.[
                                          key
                                        ] !== undefined
                                          ? formatToDatetimeLocal(
                                            currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                          )
                                          : formatToDatetimeLocal(
                                            currentClonedRow[key]
                                          )
                                      }
                                      max={new Date()
                                        .toISOString()
                                        .slice(0, 16)} // Restrict future dates
                                      onChange={(e) =>
                                        handleEditDropdownChange(
                                          e.currentTarget.value,
                                          key
                                        )
                                      } // Handle datetime input change
                                      disabled
                                    />
                                    <RxCalendar />
                                  </div>
                                ) : (
                                  <>
                                    <div className="aniMobEditInputBlk">
                                      <label>{formatKeyLabel(key)}</label>
                                      <input
                                        type="text"
                                        value={
                                          currentClonedRow[
                                            currentClonedRow.id
                                          ]?.[key] !== undefined // Check if value is defined
                                            ? currentClonedRow[
                                            currentClonedRow.id
                                            ][key]
                                            : currentClonedRow[key]
                                        }
                                        className="form-control InputTextHolder"
                                        onChange={(e) =>
                                          handleEditDropdownChange(
                                            e.currentTarget.value,
                                            key
                                          )
                                        }
                                        disabled
                                      />
                                    </div>
                                  </>
                                )
                              ) : key === "Reptils" ? (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={reptilsDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow.Reptils
                                        ? domainValues.Reptils.find(
                                          (domain) =>
                                            domain.key ===
                                            currentClonedRow.Reptils ||
                                            domain.value ===
                                            currentClonedRow.Reptils
                                        )
                                          ? {
                                            value: currentClonedRow.Reptils,
                                            label: domainValues.Reptils.find(
                                              (domain) =>
                                                domain.key ===
                                                currentClonedRow.Reptils ||
                                                domain.value ===
                                                currentClonedRow.Reptils
                                            ).value,
                                          }
                                          : (editingRows.Reptiles = null)
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.label,
                                        key
                                      );
                                      if (
                                        currentClonedRow.Reptils !=
                                        selectedOption
                                      ) {
                                        editingRows.Species = null;
                                      }
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.label
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={t("Select Reptiles")}
                                    isDisabled={true}
                                  />
                                </>
                              ) : (
                                <>
                                  <label>{formatKeyLabel(key)}</label>
                                  <Select
                                    options={reptilsDomainValues.map(
                                      (option) => ({
                                        value: option.key,
                                        label: option.value,
                                      })
                                    )}
                                    value={
                                      currentClonedRow[key]
                                        ? reptilsDomainValues.find(
                                          (domain) =>
                                            domain.value ===
                                            currentClonedRow[key]
                                        )
                                          ? {
                                            value: currentClonedRow[key],
                                            label: reptilsDomainValues.find(
                                              (domain) =>
                                                domain.value ===
                                                currentClonedRow[key]
                                            ).value,
                                          }
                                          : null
                                        : null
                                    }
                                    onChange={(selectedOption) => {
                                      handleEditDropdownChange(
                                        selectedOption.label,
                                        key
                                      );
                                      GetSpeciesDropdown(
                                        selectedOption
                                          ? selectedOption.label
                                          : ""
                                      );
                                    }}
                                    components={{
                                      DropdownIndicator: CustomDropdownIndicator,
                                    }}
                                    className="react-select-container"
                                    classNamePrefix="react-select"
                                    placeholder={`Select ${key}`}
                                    isDisabled={true}
                                  />
                                </>
                              )
                            ) : (
                              <>
                                <div className="aniMobEditInputBlk">
                                  <label>{formatKeyLabel(key)}</label>
                                  <input
                                    type="text"
                                    value={currentClonedRow[key]}
                                    name={key}
                                    onChange={(e) =>
                                      handleEditDropdownChange(
                                        e.currentTarget.value,
                                        key
                                      )
                                    }
                                    className="form-control InputTextHolder"
                                    disabled
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
              </div>
            </div>, widgetMobEl
          )}
        </>
      )}
    </>
  );
};

export default AnimalSightingMobilePending;
